import React from "react";
import { TextField } from "..";
import styles from "./textfield-label.module.scss";

const TextfieldWithLabel = ({ label, ...props }) => {
  return <TextField {...props} prefix={<div className={styles.container}>{label}</div>} />;
};

export default TextfieldWithLabel;
